module.exports = __webpack_public_path__ + "img/run_icon.fb584868.svg";